<template>
  <div style="background-color: rgb(246, 246, 246);margin-top: 64px;padding-top: 12px;padding-bottom: 12px;">
    <div class="informationDetail-contemt">
      <div class="informationDetail-title">
        <div class="informationDetail-title-right">
          <div>当前位置：</div>
          <div @click="goIndex()">首页></div>
          <div @click="goinformation()">资讯></div>
          <div @click="goinformations(level1.id, level2.id)">{{level1.name}}></div>
          <div @click="goinformations(level1.id, level2.id)">{{level2.name}}></div>
          <div>正文</div>
        </div>
      </div>
      <div class="informationDetail-titles">{{newsInfo.title}}</div>
      <div class="informationDetail-time">
        <div>{{newsInfo.createTime}}</div>
      </div>
      <div class="big_text" style='white-space: pre-wrap;margin-left: 94px;margin-right: 34px;' v-html="newsInfo.content"></div>
      <i style="display: block;margin-top: 10px;margin-left: 94px;" v-for="(item, index) in newsInfo.fileList" :key="index" v-downLoadUrl="handleExport(item)">{{ item.fileName }}</i>
      <div class="line"></div>
      <div class="informationDetail-top" v-if="newsInfo.preInfo" @click="topTitle(newsInfo.preInfo.id)">上一篇：{{newsInfo.preInfo.title}}</div>
      <div class="informationDetail-next" v-if="newsInfo.nextInfo" @click="nextTitle(newsInfo.nextInfo.id)">下一篇：{{newsInfo.nextInfo.title}}</div>
    </div>
  </div>
</template>

<script>
import request from '../util/request.js'

export default ({
  data () {
    return {
      id: '',
      typeId: '',
      newsInfo: {},
      level1: {},
      level2: {},
      content: ''
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  mounted () {
    this.id = this.$route.query.id
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: '/web/index/newsDetail',
        data: JSON.stringify({
          id: that.id
        })
      }).then(
        (res) => {
          that.newsInfo = res.data.data.newsInfo
          that.level1 = res.data.data.level1
          that.level2 = res.data.data.level2
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    handleExport (file) {
      let obj = {}
      obj = {
        url: file.fileUrl,
        name: file.fileName
      }
      return obj
    },
    topTitle (id) {
      this.id = id
      this.getData()
    },
    nextTitle (id) {
      this.id = id
      this.getData()
    },
    goIndex () {
      this.$router.push({
        path: '/'
      })
    },
    goinformation () {
      this.$router.push({
        path: '/information'
      })
    },
    goinformations (id, ids) {
      this.$router.push({
        path: '/information',
        query: {
          oneId: id,
          twoId: ids
        }
      })
    }
  }
})
</script>

<style>
.informationDetail-contemt{
  width: 1156px;
  margin: 0 auto;
  background-color: #fff;
  padding-left: 15px;
  padding-right: 29px;
  padding-bottom: 100px;
}
.informationDetail-title{
  padding-top: 34px;
  overflow: hidden;
  border-bottom: 1px solid #CECECE;
  padding-bottom: 9px;
}
.informationDetail-title-right{
  float: left;
  overflow: hidden;
  color: #9A9A9A;
  font-size: 15px;
  margin-top: 4px;
}
.informationDetail-title-right div{
  float: left;
  cursor: pointer;
}
.informationDetail-titles{
  text-align: center;
  margin-top: 49px;
  line-height: 56px;
  font-size: 25px;
  color: #000;
  font-weight: 500;
}
.informationDetail-time{
  margin-bottom: 65px;
}
.informationDetail-time div{
  text-align: center;
  margin-top: 29px;
  color: #D8D8D8;
  font-size: 16px;
  padding-bottom: 9px;
  border-bottom: 1px dotted #C8C8C8;
}
.line{
  margin-top: 30px;
  border: 1px solid #979797;
  margin-bottom: 33px;
}
.informationDetail-top{
  text-align: right;
  color: #5E5E5E;
  margin-bottom: 17px;
  font-size: 16px;
  cursor: pointer;
}
.informationDetail-next{
  text-align: right;
  color: #5E5E5E;
  font-size: 16px;
  cursor: pointer;
}
.big_text img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/informationDetail.vue